import React from 'react';

export default function SectionHeader({ eyebrow, title, accent, copy, align = 'left' }) {
  const centered = align === 'center';

  return (
    <div className={`section-header ${centered ? 'section-header-center' : ''}`} data-reveal>
      <div className={`overline flex items-center gap-3 mb-4 ${centered ? 'justify-center' : ''}`}>
        <div className="w-8 h-[2px] bg-[#FF2A00]" />
        <span>{eyebrow}</span>
      </div>
      <h2 className="section-title">
        {title}
        {accent && (
          <>
            <br />
            <span>{accent}</span>
          </>
        )}
      </h2>
      {copy && <p className={`section-copy ${centered ? 'mx-auto' : ''}`}>{copy}</p>}
    </div>
  );
}
